import React from 'react';
import classNames from 'classnames';
import { flowRight } from 'lodash';
import { HeaderMobile } from '../../../common/components/header';
import Link from '../../../common/components/link/internal-link';
import withFontClassName from '../../../common/hoc/with-font-class-name';
import HeaderBackButton from '../../components/header-back-button';
import SearchHeader from './search-header';
import styles from './search-mobile-header.scss';

type Props = {
  contentFontClassName?: string;
} & Omit<
  React.ComponentProps<typeof SearchHeader>,
  'component' | 'left' | 'inputClassName' | 'borderClassName' | 'iconClassName' | 'showWidget'
>;

const SearchMobileHeader = ({ contentFontClassName, ...otherProps }: Props) => {
  const left = (
    <div className={styles.backButton}>
      <HeaderBackButton arrow text="" component={Link} to="/" />
    </div>
  );

  const inputClassName = classNames('blog-button-primary-text-color', contentFontClassName);

  const borderClassName = 'blog-button-primary-text-background-color';

  const iconClassName = 'blog-button-primary-icon-fill';

  return (
    <SearchHeader
      component={HeaderMobile}
      left={left}
      inputClassName={inputClassName}
      borderClassName={borderClassName}
      iconClassName={iconClassName}
      showWidget={false}
      {...otherProps}
    />
  );
};

export default flowRight(withFontClassName)(SearchMobileHeader);
